document.addEventListener("DOMContentLoaded", function () {
  // 跳过Shopify编辑器模式（避免后台预览报错）
  if (Shopify.designMode) return;

  // ============== 1. 初始化Tab切换功能 ==============
  const tabContainer = document.querySelector('.tab-navigation');
  const tabItems = document.querySelectorAll(".tab-nav-item[data-tab-id]");
  const contentSections = document.querySelectorAll("[data-tab-section-id]");// 仅获取【内容切换类型】的Tab（排除跳转链接类型）

  // 健壮判断：没有Tab项，直接终止代码（避免报错）
  if (!tabItems.length || !tabContainer) return;

  // 初始化：显示所有第一个Tab对应的内容
  const firstTabId = tabItems[0].dataset.tabId;
  if (firstTabId) {
    document.querySelectorAll(`[data-tab-section-id="${firstTabId}"]`).forEach(sec => {
      sec.classList.add("tab-active");
    });
  }

  // 绑定Tab点击事件
  tabItems.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      const currentTabId = tab.dataset.tabId;

      // 切换Tab激活状态
      tabItems.forEach((item) => {
        item.classList.remove("active");
        item.setAttribute("aria-selected", "false");
      });
      tab.classList.add("active");
      tab.setAttribute("aria-selected", "true");

      // 切换内容Section显示/隐藏
      contentSections.forEach((section) => {
        section.classList.remove("tab-active");
        section.dataset.tabSectionId === currentTabId && section.classList.add("tab-active");
        // if (section.dataset.tabSectionId === currentTabId) {
        //   section.classList.add("tab-active");
        // }
      });
    });
  });

  // ============== 2. 🔥 集成你的参考逻辑：粘性状态监听（滚动监听+双阈值防抖） ==============
  let lastStickyState = false; // 记录上一次粘性状态
  // 双阈值配置（防临界抖动，可微调）
  const ACTIVE_THRESHOLD = 20;   // 激活粘性阈值
  const DEACTIVE_THRESHOLD = 50; // 取消粘性阈值

  // 滚动更新粘性状态核心函数
  function updateStickyState() {
    const navViewportTop = tabContainer.getBoundingClientRect().top;
    let isStickyActive;

    // 双阈值判断：避免临界值反复切换
    if (lastStickyState) {
      // 当前已粘性：超过取消阈值才关闭
      isStickyActive = navViewportTop <= DEACTIVE_THRESHOLD;
    } else {
      // 当前未粘性：低于激活阈值才开启
      isStickyActive = navViewportTop <= ACTIVE_THRESHOLD;
    }

    // 仅状态变化时操作DOM（性能优化）
    if (isStickyActive !== lastStickyState) {
      // 切换粘性样式类
      isStickyActive 
        ? tabContainer.classList.add("sticky-active") 
        : tabContainer.classList.remove("sticky-active");
      
      // 切换z-index：粘性=3，默认=2
      lastStickyState = isStickyActive;
    }
  }

  // 监听滚动 + 初始加载执行一次
  window.addEventListener("scroll", updateStickyState);
  updateStickyState();
});
